import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VisaoLeadsComponent } from './visao-leads.component';
import { ResumoLeadsComponent } from './resumo-leads/resumo-leads.component';
import { ResumoLeadsGridComponent } from './resumo-leads-grid/resumo-leads-grid.component';
import { StatusContatoAtivoComponent } from './status-contato-ativo/status-contato-ativo.component';
import {ChartModule} from 'primeng/chart';
import { FluxoConversaoComponent } from './fluxo-conversao/fluxo-conversao.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { InsucessoLeadsQualificadosComponent } from './Insucesso-leads-qualificados/Insucesso-leads-qualificados.component';
import {ToolbarModule} from 'primeng/toolbar';
import {ButtonModule} from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { FiltroService } from '../../../shared/filtro/filtro.service';
import { DropdownModule } from 'primeng/dropdown';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import { PrimeiroContatoComponent } from './primeiro-contato/primeiro-contato.component';
import { ComumModule } from '../../../shared/comum.module';
import { TranslateModule } from '@ngx-translate/core';
import { translateLoaderNBS } from '../../../shared/translate-loader/translateLoader';

@NgModule({
  imports: [
    CommonModule,
    ComumModule,
    ChartModule,
    NgApexchartsModule,
    ToolbarModule,
    ButtonModule,
    CalendarModule,
    FormsModule,
    DialogModule,
    DropdownModule,
    ReactiveFormsModule,
    ProgressSpinnerModule,
    TranslateModule.forRoot(translateLoaderNBS)
  ],
  declarations: [
    VisaoLeadsComponent, 
    ResumoLeadsComponent, 
    ResumoLeadsGridComponent, 
    StatusContatoAtivoComponent,
    FluxoConversaoComponent,
    InsucessoLeadsQualificadosComponent,
    PrimeiroContatoComponent
  ],
  providers: [FiltroService],
})
export class VisaoLeadsModule { }
